import { createSlice } from "@reduxjs/toolkit";
import { closeModalAction, OpenModalAction, setErrorBoundryAction, setInitialLoaderAction, setMainLoadingAction, setChatOpenAction, setPageTitleAction, setSearchKeywordAction, toggleSideNavAction, setSupplierSearchKeywordAction } from "../actions/CommonActions";
export const CommonSlice = createSlice({
  name: "common",
  initialState: {
    ischat: false,
    isMainLoading: false,
    initialLoader: true,
    errorBoundry: false,
    pageTitle: '',
    sideBarOpen: true,
    modalOpen: false,
    searchKeyword: '',
    supplierSearchKeyword: { org_id:0,div_id: 0, page_no: 0, searchText: "", designation: "all" }
  },
  reducers: {
    setChatOpen: setChatOpenAction,
    setMainLoading: setMainLoadingAction,
    setInitialLoader: setInitialLoaderAction,
    setErrorBoundry: setErrorBoundryAction,
    setPageTitle: setPageTitleAction,
    toggleSideNav: toggleSideNavAction,
    OpenModal: OpenModalAction,
    closeModal: closeModalAction,
    setSearchKeyword: setSearchKeywordAction,
    setSupplierSearchKeyword: setSupplierSearchKeywordAction
  },
});
export const { setMainLoading, setChatOpen, setInitialLoader, setErrorBoundry, setPageTitle, toggleSideNav, OpenModal, closeModal, setSearchKeyword, setSupplierSearchKeyword } = CommonSlice.actions;
export default CommonSlice.reducer;